export default __webpack_public_path__ + "static/media/28.4a94bb3c.jpg";